import { useMemo } from "react";
import isEmpty from "lodash/isEmpty";

function useAuthority(userAuthority = [], authority = [], emptyCheck = false) {
  const roleMatched = useMemo(() => {
    const safeUser = Array.isArray(userAuthority) ? userAuthority : [];
    const safeAuth = Array.isArray(authority) ? authority : [];
    return safeAuth.some((role) => safeUser.includes(role));
  }, [authority, userAuthority]);

  if (
    isEmpty(authority) ||
    isEmpty(userAuthority) ||
    typeof authority === "undefined"
  ) {
    return !emptyCheck;
  }

  return roleMatched;
}

export default useAuthority;
